import * as mimeTypes from 'mime-types';
export class MimeTypeService {
    static lookup(fileName) {
        return mimeTypes.lookup(fileName) || 'application/octet-stream';
    }
}
//# sourceMappingURL=MimeTypeService.js.map